module.exports = __webpack_public_path__ + "static/images/drop-off-after-route-optimize.tahnlyK.svg";